import { alpha, Box, Tooltip, useTheme } from '@mui/material'
import { getClient } from '@sentry/react'
import { MdSupportAgent } from 'react-icons/md'

interface SupportProps {
  collapsed: boolean
}

function Support({ collapsed }: SupportProps) {
  const theme = useTheme()

  const handleOpenFeedback = async () => {
    const client = getClient()
    const feedback = client?.getIntegrationByName('Feedback')

    if (!feedback) return

    const form = await (feedback as any).createForm()
    form.appendToDom()
    form.open()
  }

  return (
    <Box
      component="button"
      onClick={handleOpenFeedback}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 1.5,
        mx: 1,
        mb: 2,
        borderRadius: 3,
        textDecoration: 'none',
        color: theme.palette.text.secondary,
        backgroundColor: alpha(theme.palette.background.default, 0.3),
        border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
        fontWeight: 600,
        fontSize: '0.875rem',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
          color: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          borderColor: alpha(theme.palette.primary.main, 0.2),
          transform: 'scale(1.02)',
          '& .support-icon': {
            color: theme.palette.primary.main,
          },
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      }}>
      <Tooltip
        disableHoverListener={!collapsed}
        title="Reporte um erro"
        placement="right">
        <Box
          className="support-icon"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
            transition: 'all 0.2s ease',
            flexShrink: 0,
            '& svg': {
              display: 'block',
              fontSize: '1.5rem',
            },
          }}>
          <MdSupportAgent />
        </Box>
      </Tooltip>

      {!collapsed && <Box sx={{ fontWeight: 600 }}>Suporte</Box>}
    </Box>
  )
}

export default Support
